import React from 'react';

import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

export function TextEditor({ value = '', onChange }: { value?: string; onChange?: (val: string) => void }) {
    const editor = useEditor({
        extensions: [StarterKit],
        content: value,
        onUpdate: ({ editor }) => {
            onChange?.(editor.getHTML());
        },
    });

    return <div className="tiptap-container">
        <EditorContent editor={editor} className="tiptap" />
    </div>;
};